import { useEffect, useState } from 'react'
import { useRouter } from "../../../hooks/router";
import { verify_root } from "../../../server/requests";

import './VerifyPin.scss'

import ErrorMessage from "../../AlertMessage/AlertMessage";
import Loading from "../../Loading/Loading";

import img_back from "../images/back-button.png";
import { isIOS, isMobile } from 'react-device-detect';
import { translateWord,crypt } from '../../Util/util';

export default function VerifyPIN({ user, setShowProtectedField, callBackIsProtected }) {
    const router = useRouter()

    const [inputs, setInputs] = useState([
        { id: 0, value: '', default_val: '', active: true },
        { id: 1, value: '', default_val: '', active: false },
        { id: 2, value: '', default_val: '', active: false },
        { id: 3, value: '', default_val: '', active: false }
    ])

    const [alertMessage, setAlertMessage] = useState({
        type: 'error',
        show: false,
        text: ''
    })
    const [showLoading, setShowLoading] = useState(false)


    useEffect(() => {

        if (router.pathname === '/subusers/verify' || router.pathname === '/' || router.pathname.indexOf('player') != -1) {
            document.onkeyup = onKeyPressVerify
        } else {
            document.onkeyup = () => { }
        }

    }, [router.query])


    const request_verify_pin = (pin) => {
        const body = {
            password: pin,
            id: user.id,
        }
        verify_root(body, data => {
            localStorage.setItem('token', crypt('token', data))
            refresh_pin()
            if (router.pathname === '/' || router.pathname.indexOf('player') != -1) {
                setShowProtectedField(false)
                callBackIsProtected(router.query.id)
            } else router.push('/')
        }, err => {
            refresh_pin()
            setAlertMessage({
                type: 'error',
                text: translateWord(err),
                show: true
            })
        })
    }


    function onKeyPressVerify(e) {
        if (!isNaN(e.key)) {

            const x = inputs.find(k => k.active === true)
            if (x) {
                x.default_val = ''
                x.value = ''
                x.value = e.key
                x.default_val = '*'
                x.active = false
            }

            let newArray = inputs
            if (newArray.indexOf(x) + 1 !== 4) {
                newArray[newArray.indexOf(x) + 1].active = true
            } else {
                setShowLoading(true)
                let pin = []
                inputs.forEach(e => pin.push(e.value))
                document.onkeyup = function () { }
                request_verify_pin(pin.join(''))


            }

            setInputs([...newArray])

        } else if (e.key === 'Backspace') {
            const x = inputs.find(k => k.active === true)
            if (x) {
                let newArray = inputs

                if (newArray[newArray.indexOf(x) - 1]) {
                    x.active = false
                    newArray[newArray.indexOf(x) - 1].active = false
                    newArray[newArray.indexOf(x) - 1].default_val = ''
                    newArray[newArray.indexOf(x) - 1].value = ''
                    newArray[newArray.indexOf(x) - 1].active = true
                }
                setInputs([...newArray])
            }
        }
    }

    const refresh_pin = () => {
        document.onkeyup = onKeyPressVerify
        let newArray = inputs
        newArray.forEach(e => {
            e.value = ''
            e.default_val = ""
            e.active = false
            if (e.id === 0) e.active = true
        })
        setAlertMessage(k => ({ ...k, show: false }))
        setShowLoading(false)
    }

    const btn_verify_pin = (e) => {

        if (!e.value) return

        let x = inputs.find(k => k.active === true)
        x.active = false
        e.active = true

        let newArray = inputs
        setInputs([...newArray])
    }


    const btn_back_protected = () => {

        if (router.pathname === '/' || router.pathname.indexOf('player') != -1) router.history.goBack()
        else router.push('/subusers')

        document.onkeyup = function () {
        }
    }

    return (
        <div className="parent_verify_pin">
            {showLoading ? <Loading /> : null}

            <ErrorMessage type={alertMessage.type} show={`${alertMessage.show}`} text={alertMessage.text} />
            <img className="back_to_sub_user verify" src={img_back} alt={''} onClick={btn_back_protected} />

            <h1>Enter your PIN to access this profile</h1>
            {
                isMobile ?
                    <div className="fields">
                        {
                            inputs.map(e => {
                                return (
                                    <div key={e.id} className={e.active ? 'field_verify active' : 'field_verify'}>
                                        <input
                                            type='text'
                                            pattern="[0-9]*"
                                            inputmode="numeric"
                                            autoFocus={e.id === 0 ? true : false}
                                            style={{ backgroundColor: e.value.length ? ' #38334D' : 'white' }}
                                            onClick={() => btn_verify_pin(e)}
                                            className={isIOS ? 'field_verify_inp' : 'field_verify_inp android'}
                                            value={e.default_val}
                                        />
                                    </div>
                                )
                            })
                        }
                    </div>

                    :
                    <div className="fields">
                        {
                            inputs.map(e => {
                                return (
                                    <div
                                        key={e.id}
                                        autoFocus={e.id === 0 ? true : false}
                                        style={{ backgroundColor: e.value.length ? ' #38334D' : 'white' }}
                                        onClick={() => btn_verify_pin(e)}
                                        className={e.active ? 'field_verify active' : 'field_verify'}
                                    ><span>{e.default_val}</span></div>
                                )
                            })
                        }
                    </div>
            }

        </div>
    )
} 